import React, { useEffect } from "react";
import { DescriptionMap, VariationTableProps } from "./variationsTable.types";
import './styles.scss'
import Input from "../../../../../ui/molecules/input";

export const VariationTable: React.FC<VariationTableProps> = ({
    ...props
}) => {
    const [rows, setRows] = React.useState<string[]>(Array.from({ length: 9 }, _ => '0'));

    const handleOnChange = (value: string, idx: number) => {
        let currRows = [...rows];
        if(currRows[idx][0] === '0')
            return

        currRows[idx] = currRows[idx][0] + value
        props.onChange && props.onChange(currRows);
        setRows(currRows);
    };

    const handleOnCheckboxClick = (b: boolean, idx: number) => {
        if(props.disabled)
            return

        let currRows = [...rows];
        currRows[idx] =  b ? '1' + currRows[idx].slice(1) : '0'
        props.onChange && props.onChange(currRows);
        setRows(currRows);
    };

    useEffect(() => {
        if (props.defaultValue)
            setRows(props.defaultValue) // LENGTH MUST BE NINE
    }, [props.defaultValue])


    return (
        <div>
            <table id="variations-table" className="w-[100%]">
                <thead className="h-[30px] uppercase">
                    <tr>
                        <th className="w-[40px] rounded-tl-[12px]"></th>
                        <th className="w-[30%]">Descrizione</th>
                        <th className="w-[10%]" style={{textAlign: 'center'}}>Variazione</th>
                        <th className="w-[60%]">Dettaglio</th>
                        <th className="w-[40px] rounded-tr-[12px]"></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((r, index) => (
                        <tr
                            key={index}
                            style={{
                                color: "#4D797F",
                                background: index % 2 === 0 ? "#D9E6E8" : "#FFFFFF"
                            }}
                        >
                            <td></td>
                            <td className="w-[30%]">{DescriptionMap.get(index)}</td>
                            <td className="w-[10%]">
                                <div
                                    className={`checkbox ${r[0] === '1' ? `selected` : ""
                                        }`}
                                        onClick={() => handleOnCheckboxClick(r[0] !== '1', index)}    
                                ></div>
                            </td>
                            {
                                props.disabled ?
                                    <td className="w-[60%]">{r.slice(1)}</td> :
                                    <td className="w-[60%]">
                                        <Input
                                            value={r.slice(1)}
                                            onChangeText={(text) => handleOnChange(text, index)} 
                                            />
                                    </td>
                            }
                            <td></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}